module.exports = __webpack_public_path__ + "img/logo.f582a01f.svg";